import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useAppState, useAppDispatch } from "@/store/useApp";
import { CopilotChat } from "./CopilotChat";
import { XIcon } from "lucide-react";

export const CopilotPanel = () => {
  const currentDocument = useAppState((s) => s.currentDocument);
  const copilotVisible = useAppState((s) => s.copilotVisible);
  const dispatch = useAppDispatch();

  if (!copilotVisible) return null;

  return (
    <aside className="w-[365px] p-4 border bg-purple-50 border-purple-200 flex flex-col rounded-xl ml-6 mb-10 mt-2">
      <div className="flex items-center justify-between mb-4">
        <Badge className="bg-purple-50 text-purple-600 border-purple-300 border-1 font-medium">
          AI Copilot
        </Badge>
        <Button
          variant="ghost"
          size="icon"
          className="ml-2 text-purple-700 hover:bg-purple-200"
          aria-label="Close"
          onClick={() => dispatch({ type: "TOGGLE_COPILOT" })}
        >
          <XIcon className="size-5 border-1 border-purple-700 rounded-md" />
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <CopilotChat
          documentId={currentDocument!.id}
        />
      </div>
    </aside>
  );
};
